import { render, staticRenderFns } from "./orderDetailDialog.vue?vue&type=template&id=06d96c71&scoped=true"
import script from "./orderDetailDialog.vue?vue&type=script&lang=js"
export * from "./orderDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./orderDetailDialog.vue?vue&type=style&index=0&id=06d96c71&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d96c71",
  null
  
)

export default component.exports